import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import AppShell from "@/layouts/AppShell";
import Dashboard from "@/pages/Dashboard";
import KpiTemplateEditor from "@/pages/KpiTemplate";
import AgentCRM from "@/pages/AgentCRM";
import TeamView from "@/pages/TeamView";
import TrafficLights from "@/pages/TrafficLights";
import Notifications from "@/pages/Notifications";
import Providers from "@/pages/Providers";
import Partners from "@/pages/Partners";
import PartnerRoom from "@/pages/PartnerRoom";
import Profile from "@/pages/Profile";

const TOAST_OPTIONS = {
  style: {
    background: "#0F0F0F",
    border: "1px solid #27272A",
    borderRadius: 0,
    color: "#fff",
    fontFamily: "'IBM Plex Sans', sans-serif",
  },
};

function ProtectedShell() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
        <div className="hairline px-6 py-4 font-display uppercase tracking-widest text-xs">
          <span className="text-[#39FF14]">▍</span> Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return <AppShell />;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth callback (avoid race with ProtectedRoute)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route element={<ProtectedShell />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/kpi-template" element={<KpiTemplateEditor />} />
        <Route path="/crm" element={<AgentCRM />} />
        <Route path="/team" element={<TeamView />} />
        <Route path="/traffic-lights" element={<TrafficLights />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/partners/:id" element={<PartnerRoom />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={TOAST_OPTIONS}
            />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}
